import React from 'react'
import { useIntl } from 'react-intl'
import {
  ousterTagDetail,
  wrapper,
  leftArrow,
  backLink,
  previewCardContainer,
  tagName,
} from './index.module.css'
import MainBlackHeader from '../MainBlackHeader'
import WpBlogPostPreview from '../WpBlogPostPreview'
import SEO from '../SEO'
import Link from '../Link'
import ArrowRight from '../../../assets/images/ArrowRightNoFill.svg'

import { getLocaleData, mapLocaleData } from '../../utils'

const WpTagPage = ({ data, defaultdata, location }) => {
  const intl = useIntl()
  const blogTitle = intl.formatMessage({ id: 'blog.title' })
  const backToBlog = intl.formatMessage({ id: 'blog.back' })
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  const postsTagged = intl.formatMessage({ id: 'blog.postsTagged' })
  const mutatedData = data
  const mutatedPosts = data.posts.nodes
  return (
    <>
      <SEO
        {...mutatedData}
        seoTitle={mutatedData.title}
        description={mutatedData.excerpt}
        slug={`${homeUrl}tag/${mutatedData.sharedSlug}`}
      />
      <MainBlackHeader
        title={blogTitle}
        ctaUrl={homeUrl}
        secondaryMode
      ></MainBlackHeader>
      <div className={ousterTagDetail}>
        <div className={wrapper}>
          <div className={backLink}>
            <Link to={homeUrl}>
              <ArrowRight className={leftArrow} />
              {backToBlog}
            </Link>
            {mutatedData.name && (
              <div className={tagName}>
                {postsTagged}: <h1>{mutatedData.name}</h1>
              </div>
            )}
          </div>
          <div className={previewCardContainer}>
            {mutatedPosts.map((post, idx) => {
              return (
                <WpBlogPostPreview
                  defaultdata={defaultdata}
                  data={post}
                  key={idx}
                  location={location}
                />
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default WpTagPage
